/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import Services from '../services/index';
import ContextProcessor from '../context/context-processor';
import { SET_PROPERTY } from '../store/state/actions';
import { dispatch } from '../store/state/state-manager';

class DeclareExpressionHandler {
  static handleExpression(source: string, value: string, target: string, context: string) {
    const newContext = this.getContext(source, context);
    const declareExpression = {
      action: 'decexp',
      params: {
        source,
        value,
        targets: target
      },
      context: newContext
    };

    const reqObj = {
      actionObject: declareExpression
    };

    Services.fetchData(reqObj)
      .then((res) => res.json())
      .then((jsonData) => {
        this.updateState(jsonData, context);
      })
      .catch((error) => window.console.log(error));
  }

  static getContext(ref: string, context: string) {
    const topPage = ref.substring(0, ref.indexOf('.'));
    const className =
      ContextProcessor.getPropertyValue(`${topPage}.pxObjClass`, null, context) ||
      ContextProcessor.getPropertyValue(`${topPage}.pyClassName`, null, context);

    return {
      name: topPage,
      class: className
    };
  }

  static updateState(data: { [key: string]: string }, context: string) {
    Object.keys(data).forEach((key) =>
      dispatch({
        type: SET_PROPERTY,
        payload: {
          context,
          reference: key,
          value: data[key]
        }
      })
    );
  }
}

export default DeclareExpressionHandler;
